import { ChangeDetectorRef, Directive, ElementRef, EventEmitter, Input, Output, Renderer2, ViewContainerRef } from '@angular/core';
import { BaseComponent } from 'sharedFeatures/base';
import { Utils } from 'sharedFeatures/utils';
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { DialogCreator } from "./dialog-creator";

declare var jQuery: JQueryStatic & {topZIndex: (selector?:string) => number};

class SlideMode {
    public static UP: string = 'up';
    public static DOWN: string = 'down';
}

@Directive()
export class PopupComponent extends BaseComponent {

    @Input()
    backgroundFill = 'g2Background';

    @Input()
    cornerRadius: number = 20;

    @Input()
    testId = "";
    
    isNeedEsc: boolean = true;

    topCornerRadius: number = 0;
    bottomCornerRadius: number = 0;

    processEscape: boolean = true;
    closeAction: string = 'destroy'; //hide or destroy

    title: string = '';

    public width : number = 600;
    public height: number = 300;

    protected windowContentBody: any;

    public static focusableSelector: string = 'a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]';

    public topest: boolean = false;

    isModal: boolean = false;
    dimBackgroundCls: string = 'b3Background-important';
    dimOpacity: number = 0.6;

    private maskEl: Element | undefined;
    private hidden: boolean = true;

    protected shadowStyle: string = 'none';

    private xPos: number = 0;
    private yPos: number = 0;
    private browserWidth: number = 0;
    private browserHeight: number = 0;

    @Input() dialogCreator: DialogCreator | undefined;

    @Output() afterinit: EventEmitter<any> = new EventEmitter();
    getAfterInit(): EventEmitter<any> {

        return this.afterinit;

    }

    @Output() afterviewinit: EventEmitter<any> = new EventEmitter();
    getAfterViewInit(): EventEmitter<any> {

        return this.afterviewinit;

    }

    @Output() onclose: EventEmitter<any> = new EventEmitter();
    getOnClose(): EventEmitter<any> {

        return this.onclose;

    }

    @Output()
    private aftershow: EventEmitter<any> = new EventEmitter();

    private params: Map<string, any> = new Map<string, any>();

    protected zIndex: number | undefined = undefined;

    private defaultZIndex = 1000;

    private keyupUnlisten: Function | undefined;
    private focusoutUnlisten: Function | undefined;

    private _useFadeIn: boolean = true;

    private slideMode = SlideMode.UP;

    wasClosed: boolean = false;

    protected owner: BaseComponent | undefined;


    public get useFadeIn(): boolean {
        return this._useFadeIn;
    }

    public set useFadeIn(newVal: boolean) {
        this._useFadeIn = newVal;
        if (this._useSlide && newVal) this._useSlide = false;
    }

    private _useSlide: boolean = false;

    public get useSlide(): boolean {
        return this._useSlide;
    }

    public set useSlide(newVal: boolean) {

        this._useSlide = newVal;
        if (this._useFadeIn && newVal) this._useFadeIn = false;

    }


    constructor(element: ElementRef,
                r: Renderer2,
                protected viewContainerRef: ViewContainerRef,
                protected chDet: ChangeDetectorRef
    ) {
        super(element, r);
        this.browserWidth = document.documentElement.clientWidth;
        this.browserHeight = document.documentElement.clientHeight;

        this.r.setAttribute(this.getElDom(), 'tabindex', "-1");
        this.r.setStyle(this.getElDom(), 'position', 'absolute');
        if (this.zIndex) this.r.setStyle(this.getElDom(), 'z-index', this.zIndex);
        if (this.hidden) this.r.setStyle(this.getElDom(), 'display', 'none');

        this.keyupUnlisten = this.r.listen(this.getElDom(), 'keyup',
            ev => {
                if (ev.keyCode === 13) // Enter
                    this.onEnterHandle(ev);
                else if (ev.keyCode === 27 && this.isNeedEsc) // Esc
                    this.onEscape(ev);
            });

        this.focusoutUnlisten = this.r.listen(this.getElDom(), 'focusout',
            ev => this.onFocusOut(ev));
    }

    public setModal(isModal: boolean) {
        this.isModal = isModal;
    }

    protected ngOnInit() {

        this.afterinit.emit();

    }

    setDialogCreator(dialogCreator: DialogCreator): void {

        this.dialogCreator = dialogCreator;

    }

    getDialogCreator(): DialogCreator {

        if (this.dialogCreator === undefined)
            throw new Error('getDialogCreator error: dialogCreator is undefined');
        return this.dialogCreator;

    }

    ngAfterViewInit(): void {

        if (this.topCornerRadius) {
            this.r.setStyle(this.getElDom(), 'border-top-left-radius', this.topCornerRadius + 'px');
            this.r.setStyle(this.getElDom(), 'border-top-right-radius', this.topCornerRadius + 'px');
        }

        if (this.bottomCornerRadius) {
            this.r.setStyle(this.getElDom(), 'border-bottom-left-radius', this.bottomCornerRadius + 'px');
            this.r.setStyle(this.getElDom(), 'border-bottom-right-radius', this.bottomCornerRadius + 'px');
        }

        if (!this.topCornerRadius && !this.bottomCornerRadius) this.r.setStyle(this.getElDom(), 'border-radius', this.cornerRadius + 'px');

        this.r.addClass(this.getElDom(), this.backgroundFill);

        this.r.setStyle(this.getElDom(), 'width', this.width + 'px');
        this.r.setStyle(this.getElDom(), 'height', this.height + 'px');

        this.r.addClass(this.getElDom(), this.shadowStyle);

        this.afterviewinit.emit();

    }

    public setSize(width: number, height: number) {

        this.r.setStyle(this.getElDom(), 'width', width + 'px');
        this.r.setStyle(this.getElDom(), 'height', height + 'px');
        this.width = width;
        this.height = height;

    }

    public setBackgroundFill(color: string) {

        this.r.addClass(this.getElDom(), color);

    }

    hide(): void {
        this.zIndex = undefined;
        if (this.maskEl === undefined) return;

        if (this.useFadeIn) {
            this.hidden = true;
            jQuery(this.getElDom()).fadeOut(300, () => {
                this.r.setStyle(this.maskEl, 'height', '0px');
            });
        }
        else {
            this.r.setStyle(this.getElDom(), 'display', 'none');
            this.r.setStyle(this.maskEl, 'height', '0px');
            this.hidden = true;
        }
    }

    async close(closeHint: boolean = false): Promise<void> {
        return new Promise<void>((resolve) => {
            if (this.chDet['destroyed' as keyof ChangeDetectorRef]) {
                resolve();
            }

            this.onclose.emit();

            this.wasClosed = true;

            const $nativeElement = jQuery(this.getElDom());

            jQuery(this.getElDom()).stop(true, true);

            if (this.useFadeIn && $nativeElement.length) {
                $nativeElement.fadeOut(300, () => {
                    this.destroyDialog();
                    resolve();
                });
            } else if (this.useSlide) {
                const windowHeight = document.documentElement.clientHeight;
                jQuery(this.getElDom()).animate(
                    { top: windowHeight },
                    {
                        duration: 300,
                        always: () => {
                            this.destroyDialog();
                            if ($nativeElement.length) {
                                $nativeElement.hide(0, () => resolve());
                            }
                        },
                    }
                );
            } else {
                this.destroyDialog();
                if ($nativeElement.length) {
                    $nativeElement.hide(0, () => resolve());
                }
            }
        });
    }

    private destroyDialog() {
        if (this.keyupUnlisten)
            this.keyupUnlisten();

        if (this.focusoutUnlisten)
            this.focusoutUnlisten();

        this.hidden = true;

        this.maskEl?.remove();
        this.maskEl = undefined;
        if (this.dialogCreator) this.dialogCreator.destroyDialog(this);
    }

    onClose(): void {

        if (this.chDet['destroyed' as keyof ChangeDetectorRef]) return;

        if (this.closeAction == 'hide') this.hide();

        else this.close();

    }

    setPosition(x: number, y: number): void {

        if (Utils.isValue(x) && Utils.isValue(y)) {
            this.xPos = x;
            this.yPos = y;
            this.r.setStyle(this.getElDom(), 'top', y + 'px');
            this.r.setStyle(this.getElDom(), 'left', x + 'px');
        }

    }

    public getXPos(): number {
        return this.xPos;
    }

    public getYPos(): number {
        return this.yPos;
    }

    public getAfterShow(): EventEmitter<any> {

        return this.aftershow;

    }

    async show(x: number, y: number, focusAfterShow?: boolean, keepParent: boolean = false) {
        return new Promise<void>(resolve => {
            if (this.dialogCreator) {

                const popupModal = Array.from(this.dialogCreator.getWinRefs().keys())
                    .find(x => x.isModal && x.visibleOnPage);

                if (this.isModal && popupModal && popupModal != this && !keepParent) {
                    popupModal.close().then(_ => resolve());
                }
            }

            this.xPos = x;
            this.yPos = y;

            const currentOwner = this.getOwner();
            if (currentOwner !== undefined && !Utils.isValue(this.getZIndex())) {
                this.setZIndex(currentOwner.getZIndex());
            }

            if (this.isModal) this.showModal(x, y);
            if (Utils.isValue(x) && Utils.isValue(y)) {

                this.r.setStyle(this.getElDom(), 'top', y + 'px');
                this.r.setStyle(this.getElDom(), 'left', x + 'px');

            }

            this.hidden = false;

            const focusCallback = () => {

                if ((!Utils.isValue(focusAfterShow) || focusAfterShow) && document.activeElement) {

                    const isFocusedOutElement = !this.getElDom().contains(document.activeElement);
                    if (isFocusedOutElement) this.getElDom()['focus']();

                }

                this.aftershow.emit();

            };

            if (this.isModal && this.maskEl !== undefined) {
                this.r.setStyle(this.maskEl, 'opacity', 0);
                this.r.setStyle(this.maskEl, 'display', 'none');
                this.r.setStyle(this.getElDom(), 'display', 'none');
                jQuery(this.maskEl).fadeTo(300, this.dimOpacity);
                jQuery(this.getElDom()).fadeIn(
                    300, () => {
                        this.r.setStyle(this.getElDom(), 'opacity', '1');
                        focusCallback();
                        resolve();
                    }
                );
            }
            else {

                jQuery(this.getElDom()).hide();

                jQuery(this.getElDom()).stop(true, true);

                if (this.dialogCreator) {

                    const maxZ = this.dialogCreator.getNoModalMaxZIndex(this);

                    if (maxZ && (!Utils.isValue(this.getZIndex()) || this.isTopest)) this.setZIndex(maxZ + 1);

                }


                if (!Utils.isValue(this.getZIndex())) this.setZIndex(this.defaultZIndex);

                if (this.useFadeIn)
                    jQuery(this.getElDom()).fadeIn(300, () => { focusCallback(); resolve(); });
                else if (this.useSlide) {

                    if (this.slideMode == SlideMode.UP) {

                        if (this.height >= 0)
                            this.r.setStyle(this.getElDom(), 'top', (y + this.height) + 'px');
                        jQuery(this.getElDom()).show(0, () => resolve());

                    }
                    jQuery(this.getElDom()).animate({ top: y }, {
                        duration: 300, always: () => {

                            if (this.slideMode == SlideMode.UP) {
                                this.r.setStyle(this.getElDom(), 'bottom', '');
                                this.r.setStyle(this.getElDom(), 'top', y + 'px');
                            }

                            focusCallback();
                            resolve();
                        }
                    });

                }
                else {
                    jQuery(this.getElDom()).show(0, () => resolve());
                    focusCallback();
                }
            }

        })

    }

    async showTemporary(x: number, y: number, closeDelay: number) {
        await this.show(x, y);
        return new Promise<void>(resolve => {
            setTimeout(_ => this.close().then(_ => resolve()), closeDelay);
        });
    }

    private showModal(x: number, y: number): void {

        let topZIndex = jQuery.topZIndex(Utils.zIndexSelector);

        if (topZIndex >= 2147483600 /*2147483647*/) // Sometimes topZIndex() returns 2147483647 - it's a max z─index value
            topZIndex -= 2;

        const maskZIndex = topZIndex + 1;
        const popupZIndex = topZIndex + 2;

        this.maskEl = DomSmallUtils.generateElements('<div class="mask"></div>');
        this.r.appendChild(document.body, this.maskEl);
        this.r.setStyle(this.maskEl, 'zIndex', maskZIndex)
        if (this.dimBackgroundCls) this.r.addClass(this.maskEl, this.dimBackgroundCls);
        this.setZIndex(popupZIndex);

    }

    // Ivy has bug, event is raised multiply times if inherited component has any @HostListener
    //@HostListener('focusout', ['$event'])
    onFocusOut(ev: FocusEvent): void {
        if (this.wasClosed) return;

        if (!ev.relatedTarget || !(this.getElDom() === ev.relatedTarget || this.getElDom().contains(<HTMLElement>ev.relatedTarget))) {
            this.onFocusLeave(ev);
        }
    }

    // Override it in child classes
    protected onFocusLeave(ev: UIEvent): void {
    }

    protected onEsc() {

        this.onClose();

    }

    // Can be overriden in a descendant class
    protected onAfterEscape(): void {

    }

    protected onEnter() {

    }

    // Ivy has bug, event is raised multiply times if inherited component has any @HostListener
    //@HostListener('keydown.esc', ['$event'])
    onEscape(ev: Event): void {

        if (this.processEscape)
            this.onEsc();

        this.onAfterEscape();
    }

    // Ivy has bug, event is raised multiply times if inherited component has any @HostListener
    //@HostListener('keyup.enter', ['$event'])
    onEnterHandle(ev: Event): void {

        this.onEnter();

    }

    addParam(name: string, value: any): void {

        this.params.set(name, value);

    }

    getParam(name: string): any {

        return this.params.get(name);

    }

    public getWidth(): number {

        if (this.width === AppConsts.CALCULATE_SIZE) {
            this.width = DomSmallUtils.width(this.getElDom());
        }

        return this.width > 0 ? this.width : 0;
    }

    public getHeight(): number {

        if (this.height === AppConsts.CALCULATE_SIZE) {
            this.height = DomSmallUtils.height(this.getElDom());
        }

        return this.height > 0 ? this.height : 0;
    }

    public setWidth(width: number) {
        if (Utils.isNumeric(width))
            this.width = width;
    }

    public setHeight(height: number) {
        if (Utils.isNumeric(height))
            this.height = height;
    }

    public setBrowserWidth(width: number) {
        if (Utils.isNumeric(width))
            this.browserWidth = width;
    }

    public setBrowserHeight(height: number) {
        if (Utils.isNumeric(height))
            this.browserHeight = height;
    }

    public getBrowserWidth(): number {
        return this.browserWidth;
    }

    public getBrowserHeight(): number {
        return this.browserHeight;
    }

    public isHidden(): boolean {

        return this.hidden;

    }

    public setTopest(topest: boolean): void {

        this.topest = topest;

        if (this.topest && !this.isModal) {

            this.setZIndex(PopupComponent.getTopestZ());

        }

    }

    public static getTopestZ(): number {

        let topZIndex = jQuery.topZIndex(Utils.zIndexSelector);

        if (topZIndex >= 2147483600)
            topZIndex -= 2;

        const z = topZIndex + 1;

        return z;

    }

    public isTopest(): boolean {

        return this.topest;

    }

    public setOwner(popup: BaseComponent) {

        this.owner = popup;

    }

    public getOwner(): BaseComponent | undefined {

        return this.owner;

    }

    public getZIndex(): number | undefined {

        return this.zIndex;

    }

    public setZIndex(zIndex: number | undefined): void {
        this.zIndex = zIndex;
        this.r.setStyle(this.getElDom(), 'zIndex', this.zIndex);
    }

}
